"use strict";

exports.__esModule = true;
exports.DeviceTypeSelector = DeviceTypeSelector;
var _react = _interopRequireDefault(require("react"));
var _Selector = require("../../Core/Selector");
var _Core = require("../../Core");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function getKey(input) {
  return input;
}
function renderItemText(input) {
  return input;
}
function itemPredicate(query, tag) {
  var q = query.toLowerCase();
  return tag.toLowerCase().indexOf(q) !== -1;
}

/**
 * Allows a user to select device tag(s) from a list.
 */
function DeviceTypeSelector(props) {
  return /*#__PURE__*/_react["default"].createElement(_Core.Translator, null, function (_ref) {
    var translate = _ref.translate;
    return /*#__PURE__*/_react["default"].createElement(_Selector.Selector, _extends({
      placeholder: translate("DeviceTypeSelector.placeholder.single", "Select Device Type"),
      getKey: getKey,
      renderItemText: renderItemText,
      itemPredicate: itemPredicate
    }, props));
  });
}